import { render, staticRenderFns } from "./EpsCart.vue?vue&type=template&id=870d9dbe&"
import script from "./EpsCart.js?vue&type=script&lang=js&"
export * from "./EpsCart.js?vue&type=script&lang=js&"
import style0 from "./EpsCart.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports